export const HOME_EDUCATION_OPERATIONS_SECTION = {
  label: "EDUCATION OPERATIONS",
  subtitle: "단순히 시간을 채우는 교육이 아닌,",
  titleLines: [
    "수강부터 수료증 발급까지",
    "체계적으로 운영되는 교육 시스템",
  ],
  statusLabel: "수료증 발급 처리 완료",
};

export const HOME_EDUCATION_OPERATIONS_TICKER = {
  rowHeight: 80,
  mobileRowHeight: 70,
  intervalMs: 1400,
  transitionMs: 450,
  loopCopies: 4,
};

export const HOME_EDUCATION_OPERATIONS_ITEMS = [
  { id: "op-1", name: "김**", category: "음주운전", date: "2026-04-15" },
  { id: "op-2", name: "최**", category: "음주운전", date: "2026-02-21" },
  { id: "op-3", name: "김**", category: "성범죄", date: "2026-02-17" },
  { id: "op-4", name: "강**", category: "음주운전", date: "2026-02-14" },
  { id: "op-5", name: "홍**", category: "성범죄", date: "2026-01-24" },
  { id: "op-6", name: "박**", category: "양형이해", date: "2025-12-27" },
];
